import styled from 'styled-components';

export const StyledContainer = styled.div`
.invoice-item .invoice-logo img {
    width: auto;
    max-height: 120px;
}
`;
